<template>
  <div class="container">
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <div class="mb-24">
      <h2 class="font-24 mb-6">Twój schowek</h2>
      <span v-if="offersCount > 0" class="font-r gray-50"
        >Ilość ofert: {{ offersCount }}</span
      >
    </div>
    <div class="red">{{ infomessage }}</div>
    <template v-show="infomessage == ''">
    	<T1SchowekOffers @clipboardCounter="getClipboardCounter" />
    </template>
  </div>
</template>

<script>
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1SchowekOffers from "./T1SchowekOffers";
import T1VarLoader from "./T1VarLoader";
import axios from "axios";


export default {
  name: "clipboard-content",
  data: () => ({
    offersCount: 0,
    infomessage: "",
  }),
  components: {
    T1Breadcrumbs,
    T1SchowekOffers,
  },
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({ name: "Schowek ofert", link: "" });
      return crumbsArr;
    },
    getClipboardCounter(value) {
      this.offersCount = value;
    },
    getSchowekOper(rparams) {
      const schowek_api = "https://schowek.travelone.pl/oferta/schowek";
      return axios
        .get(schowek_api + "?" + rparams, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
  },
  mounted() {
    let that = this;
    let lparams = this.$route.query;
    let oper = "";
    let querystr = "";
    if (lparams["oper"]) {
        oper = lparams["oper"];
    }
    if (oper !== "" && (oper === "add" || oper === "del")) {
	for (let p in lparams) {
		querystr += p + "=" + lparams[p];
		querystr += "&";	
	}
        axios.defaults.withCredentials = true;
	this.getSchowekOper(querystr).then( (data) => {
        	axios.defaults.withCredentials = false;
		console.log("Executed operation on schowek.");
		T1VarLoader.loadSchowekOffers().then((data) => {
			console.log("Schowek offers updated.");
		});
	});
	if (oper === "add") {
		this.infomessage = "Twoja oferta została dodana do schowka. Za chwilę powinna pojawić się w Twoim schowku.";
	} else if (oper === "del") {
		this.infomessage = "Twoja oferta została usunięta ze schowka. Za chwilę powinna przestać być widoczna w Twoim schowku.";
	} else {
		this.infomessage = "";
	}
    }
    this.$root.$on("clipboardCounter", (val) => {
      that.offersCount = val;
    });
  },
};
</script>

<style>
.red {
	text-align:center;
	color: red;
	width: 100%;
	height: 50px;
	font-size: 20px;
}

</style>
